import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'pictureAspectRatio';

export class PictureAspectRatio extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
